<div class="cd-page">

    <!-- ── Breadcrumb ──────────────────────────────── -->
    <div class="cd-breadcrumb">
        <a class="cd-breadcrumb-link" routerLink="/customers">Customers</a>
        <span class="cd-breadcrumb-sep">/</span>
        <span class="cd-breadcrumb-current">{{ customerDetails()?.firstName }} {{ customerDetails()?.lastName }}</span>
    </div>

    <!-- ── Profile header ────────────────────────────── -->
    <div class="cd-header">
        <div class="cd-header-left">
            @if (customerDetails()?.imageUrl) {
            <img class="cd-avatar cd-avatar--img" [src]="customerDetails()!.imageUrl" [alt]="customerDetails()!.firstName"
                (error)="$any($event.target).style.display='none'; $any($event.target).nextElementSibling.style.display='flex'" />
            <div class="cd-avatar" style="display:none">
                {{ (customerDetails()?.firstName?.[0] ?? '') + (customerDetails()?.lastName?.[0] ?? '') }}
            </div>
            } @else {
            <div class="cd-avatar">
                {{ (customerDetails()?.firstName?.[0] ?? '') + (customerDetails()?.lastName?.[0] ?? '') }}
            </div>
            }
            <div class="cd-header-info">
                <h2 class="cd-name">{{ customerDetails()?.firstName }} {{ customerDetails()?.lastName }}</h2>
                <div class="cd-meta">
                    <span class="cd-status-badge"
                        [class]="'cd-status--' + (customerDetails()?.status?.toLowerCase() ?? '')">
                        <span class="cd-status-dot"></span>
                        {{ (customerDetails()?.status ?? '').split('_').join(' ') | titlecase }}
                    </span>
                    <span class="cd-meta-sep">·</span>
                    <span class="cd-meta-text">{{ customerDetails()?.email }}</span>
                    <span class="cd-meta-sep">·</span>
                    <span class="cd-meta-text">#{{ customerDetails()?.id }}</span>
                </div>
            </div>
        </div>
        <div class="cd-header-actions">
            <button class="cd-action-btn" (click)="openSendNotificationForm()">
                <i class="fa-regular fa-bell"></i> Send notification
            </button>
            <button class="cd-action-btn" (click)="openChargeCardForm()">
                <img src="assets/icons/card-receive.svg" alt="clear" class="change-wallet" /> Charge card
            </button>
            <button class="cd-action-btn" (click)="openAddCreditWalletForm()">
                <img src="assets/icons/wallet-3.svg" alt="clear" class="change-wallet" /> Change wallet
            </button>
            <button class="cd-action-btn cd-action-btn--primary" (click)="openUpdateCustomerForm()">
                <i class="fa-regular fa-pen-to-square"></i> Edit
            </button>
        </div>
    </div>

    <!-- ── Stats bar ──────────────────────────────────── -->
    @if (customerDetails()) {
    <div class="cd-stats">
        <button type="button" class="cd-stat-card cd-stat-card--clickable" (click)="onRidesCardClick($event)">
            <div class="cd-stat-icon">
                <img src="assets/icons/total-rides.svg" alt="totalRides" />
            </div>
            <div>
                <div class="cd-stat-label">Total Rides</div>
                <div class="cd-stat-value">{{ customerDetails()?.totalRides ?? 0 }}</div>
            </div>
        </button>
        <div class="cd-stat-card">
            <div class="cd-stat-icon">
                <img src="assets/icons/Wallet-ballance.svg" alt="walletBallance" />
            </div>
            <div>
                <div class="cd-stat-label">Wallet Balance</div>
                <div class="cd-stat-value" [class.cd-negative]="(customerDetails()?.walletBalance ?? 0) < 0">
                    AED {{ customerDetails()?.walletBalance }}
                </div>
            </div>
        </div>
        <div class="cd-stat-card">
            <div class="cd-stat-icon">
                <img src="assets/icons/points.svg" alt="points" />
            </div>
            <div>
                <div class="cd-stat-label">Points</div>
                <div class="cd-stat-value">{{ customerDetails()?.points | number }}</div>
            </div>
        </div>
        <div class="cd-stat-card">
            <div class="cd-stat-icon">
                <img src="assets/icons/average-rating.svg" alt="averageRating" />
            </div>
            <div>
                <div class="cd-stat-label">Avg Rating</div>
                <div class="cd-stat-value">★ {{ customerDetails()?.averageFeedbackRating ?? '---' }}</div>
            </div>
        </div>
        <div class="cd-stat-card">
            <div class="cd-stat-icon">
                <img src="assets/icons/CalendarDots.svg" alt="calendar" />
            </div>
            <div>
                <div class="cd-stat-label">Member Since</div>
                <div class="cd-stat-value">{{ customerDetails()?.createdAt | date:'d MMM yyyy' }}</div>
                <div class="cd-stat-sub">{{ customerDetails()?.createdAt | date:'hh:mm a' }}</div>
            </div>
        </div>
    </div>
    }

    <!-- ── Tabs ───────────────────────────────────────── -->
    <div class="cd-tabs">
        <button class="cd-tab" [class.cd-tab--active]="activeTab === '0'" (click)="onTabChange('0')">Overview</button>
        <button class="cd-tab" [class.cd-tab--active]="activeTab === '1'" (click)="onTabChange('1')">Activity</button>
        <button class="cd-tab" [class.cd-tab--active]="activeTab === '2'" (click)="onTabChange('2')">
            Notes
            @if (activeTab === '2') { <span class="cd-tab-badge">1</span> }
        </button>
        <button class="cd-tab" [class.cd-tab--active]="activeTab === '3'" (click)="onTabChange('3')">Wallet
            history</button>
        <button class="cd-tab" [class.cd-tab--active]="activeTab === '4'" (click)="onTabChange('4')">Card
            history</button>
        <button class="cd-tab" [class.cd-tab--active]="activeTab === '5'" (click)="onTabChange('5')">Points
            history</button>
    </div>

    <!-- ── Tab content ────────────────────────────────── -->
    <div class="cd-tab-content">
        <div [hidden]="activeTab !== '0'">
            <app-customer-details-general-info-component [customerID]="customerID"
                (customerLoaded)="onCustomerLoaded($event)" />
        </div>
        <div [hidden]="activeTab !== '1'">
            <app-customer-details-activity-component [customerID]="customerID" />
        </div>
        <div [hidden]="activeTab !== '2'">
            <app-customer-details-notes-component [customerID]="customerID" (addNoteClicked)="openAddCustomerNoteForm()" />
        </div>
        <div [hidden]="activeTab !== '3'">
            <app-customer-wallet-transaction-history-list [customerID]="customerID" />
        </div>
        <div [hidden]="activeTab !== '4'">
            <app-customer-payment-transaction-history-list [customerID]="customerID" />
        </div>
        <div [hidden]="activeTab !== '5'">
            <app-customer-points-transaction-history [customerID]="customerID" />
        </div>
    </div>

</div>

@defer (when addCreditWalletForm; prefetch on idle) {
<app-add-credit-wallet-form (addedcreditWallet)="onCreditWalletAdded()" [selectedCustomer]="customerDetails()!"
    [(visibility)]="addCreditWalletForm" />
}

@defer (when addDebitWalletForm; prefetch on idle) {
<app-add-debit-wallet-form (addedDebitWallet)="onDebitWalletAdded()" [selectedCustomer]="customerDetails()!"
    [(visibility)]="addDebitWalletForm" />
}

@defer (when chargeCardForm; prefetch on idle) {
<app-charge-customer-card-form (chargedCustomerCard)="oncardCharged()" [selectedCustomer]="customerDetails()!"
    [(visibility)]="chargeCardForm" />
}

@defer (when addCustomerNoteForm; prefetch on idle) {
<app-add-customer-note-form (addedCustomerNote)="onCustomerNoteAdded()" [selectedCustomer]="customerDetails()!"
    [(visibility)]="addCustomerNoteForm" />
}

@defer (when sendNotificationForm; prefetch on idle) {
<app-send-notification-customer-form (notificationSent)="onNotificationSent()" [selectedCustomer]="customerDetails()!"
    [(visibility)]="sendNotificationForm" />
}

@defer (when updateCustomerForm; prefetch on idle) {
<app-update-customer-form (updatedCustomer)="onCustomerUpdated()" [selectedCustomer]="customerDetails()!"
    [(visibility)]="updateCustomerForm" />
}